import EN_US from './en-us';
import FR_CA from './fr-ca';
import { dateTimeFormats } from './datetimeFormats';
import VueI18n, { I18nOptions, LocaleMessageObject, NumberFormatOptions } from 'vue-i18n';
import Vue from 'vue';
import Intl from 'intl';
import { getLocaleWithoutDialect } from './util';

export { getLocaleWithoutDialect };

// IE11 doesn't support the formatToParts functions, which are used by some of our libraries
// This sets up a polyfill when they're not available
if (!window.Intl || !window.Intl.DateTimeFormat.prototype.formatToParts) {
    // Need to specify which locales are available in our polyfill
    // tslint:disable-next-line
    require(`intl/locale-data/jsonp/en-US.js`);
    // tslint:disable-next-line
    require(`intl/locale-data/jsonp/fr-CA.js`);
    window.Intl = Intl;
}

export const fallbackLocale: keyof typeof messages = 'en-US';
const currentLocale = navigator.language || fallbackLocale;

const messages = {
    'en-US': EN_US,
    // Cast because it doesn't like the ' | undefined' aspect of partial
    // Safe because that's equivalent to just not having the key
    'fr-CA': FR_CA as LocaleMessageObject
};

const numberFormats = {
    'en-US': { currency: EN_US.currency },
    'fr-CA': { currency: FR_CA.currency as NumberFormatOptions },
};

export const supportedLocales: { [name: string]: keyof typeof messages } = {
    'English (U.S.)': 'en-US',
    'French (Canada)': 'fr-CA'
};

const options: I18nOptions = {
    locale: currentLocale,
    messages,
    dateTimeFormats,
    numberFormats,
    fallbackLocale,
    silentFallbackWarn: true
};

// VueI18n throws an error if this isn't called before the new VueI18n() call
Vue.use(VueI18n);

export default new VueI18n(options);
